/**
 * Multi-tenancy keystone (#31).
 *
 * fcat has one tenant today: Tristano's Catering. Instead of a full tenant-
 * scoping rewrite, we reserve a fixed UUID for the single brand and stamp it
 * as the DEFAULT on new CMS-style columns. If a second tenant ever lands,
 * migrations can widen the model without renumbering the first.
 *
 * DO NOT change this value — production rows reference it by default and the
 * seed row is keyed on this exact UUID.
 */
export const DEFAULT_BRAND_ID = "00000000-0000-0000-0000-000000000001" as const;
export type BrandId = typeof DEFAULT_BRAND_ID | string;

export interface Brand {
  id: string;
  slug: string;
  name: string;
  created_at: string;
  updated_at: string;
}

/** Logo shown on public pages when `app_settings.site_logo_url` is empty — the same asset marketing falls back to (#1101). */
export const LOGO_FALLBACK = "/images/logo-white.webp";
